import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { timetableActions as slice } from "../slices/timetable";
import { TimetableMapper } from "../../mappers/TimetableMapper";
import { getErrorMessage } from "../../utils/errorUtils";
import { TimetableResponseDto } from "../../shared/dtos/timetable/TimetableResponseDto";
import { TimetableSummaryDto } from "../../shared/dtos/timetable/TimetableSummaryDto";
import { UpdateTimetablePayload } from "../../shared/interfaces/timetable/UpdateTimetablePayload";
import { TimetableQueryParams } from "../../shared/dtos/timetable/TimetableQueryParams";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getTimetables =
  (params?: TimetableQueryParams) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTimetables());
    console.log(params);

    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<TimetableSummaryDto>>
      >("/timetables", {
        headers: { requiresAuth: true },
        params,
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setTimetables(data.data.content));
        dispatch(slice.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(slice.setErrorLoadingTimetables(getErrorMessage(error)));
    }
  };

export const getTimetableById =
  (id: string) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTimetable());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<TimetableResponseDto>
      >(`/timetables/${id}`, {
        headers: { requiresAuth: true },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(slice.setTimetable(data.data));
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorLoadingTimetable(message));
    }
  };

export const updateTimetable =
  (payload: UpdateTimetablePayload) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTimetableUpdate());
    try {
      const { data } = await axiosInstance.put<
        ApiResponseDto<TimetableResponseDto>
      >(`/timetables/${payload.id}`, payload.values, {
        headers: { requiresAuth: true },
      });

      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        toast.success(data.message || "Timetable status updated successfully!");
        const timetableListData = TimetableMapper.mapTimetableToSummary(
          data.data,
        );
        dispatch(slice.updateTimetableSuccess(timetableListData));
        dispatch(
          slice.setServerResponseStatus({
            operation: "update",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorUpdatingTimetable(message));
    }
  };

export const deleteTimetable =
  (id: string) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingTimetableDelete());
    try {
      const { data } = await axiosInstance.delete<ApiResponseDto<void>>(
        `/timetables/${id}`,
        {
          headers: { requiresAuth: true },
        },
      );

      if (data.status === ApiResponseStatus.SUCCESS) {
        toast.success(data.message || "Timetable deleted successfully!");
        dispatch(slice.deleteTimetableSuccess(id));
        dispatch(
          slice.setServerResponseStatus({
            operation: "delete",
            status: data.statusCode || 200,
          }),
        );
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorDeletingTimetable(message));
    }
  };

export const resetTimetableServerStatus = () => (dispatch: AppDispatch) => {
  dispatch(slice.setServerResponseStatus(null));
};
